import React, {Component} from 'react';

import { withTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import { ToastsContainer, ToastsStore, ToastsContainerPosition } from 'react-toasts';

import RightSide from './RightSide';
import Footer from './Footer';
import FileNotFound from './FileNotFound';

import {isValidEmail, isEmailAllowed, getApiUrl} from '../utils/utils';

import "../assets/css/deposit.scss"

let BASE_URL = getApiUrl()

class OpenDeposit extends Component {
    constructor(props) {
        super(props)

        this.state = {
            sendFailed: false,
            emailValue: "",
            error: false,
            errorMessage: "",
            isSend: false,
        }

    }

    getInitials(str) {
        // Séparer la chaîne en mots, récupérer la première lettre de chaque mot et la mettre en majuscule
        return str
            .split(' ') // Sépare la chaîne en un tableau de mots
            .map(word => word.charAt(0).toUpperCase()) // Récupère la première lettre de chaque mot et la met en majuscule
            .join(''); // Combine les initiales ensemble
    }

    formatDate(dateString) {
        const date = new Date(dateString); // Convertit la chaîne en un objet Date

        // Récupère les parties de la date
        const day = date.getDate(); // Jour
        const month = date.toLocaleString(navigator.language, { month: 'long' }); // Mois en toutes lettres
        const year = date.getFullYear(); // Année

        return `${day} ${month} ${year}`; // Assemble le tout au format souhaité
    }

    send() {
        if (!isValidEmail(this.state.emailValue)) {
            return this.setState({error: true, errorMessage: this.props.t("openDeposit.mailError")})
        } else if (!isEmailAllowed(this.state.emailValue)) {
            return this.setState({error: true, errorMessage: this.props.t("openDeposit.mailNotAllowed")})
        } else {
            let responseStatus
            let requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    email: this.state.emailValue,
                    openToken: this.props.openToken
                })
            }

            fetch(`${BASE_URL}/api/external/depositboxes/open/token`, requestOptions)
                .then(res => {responseStatus = res?.ok; return res})
                .then(res => {
                    if(responseStatus) {
                        this.setState({isSend: true})
                        ToastsStore.success(this.props.t("openDeposit.emailSended"))
                    } else {
                        this.setState({
                            isSend: false,
                            error: true,
                            errorMessage: "Error"
                        })
                    }
                })
        }

    }

    checkToaster = (toaster) => {
        if (toaster.length !== 0) {
            if (toaster.toasterColor === "error") {
                ToastsStore.error(toaster.toasterText, 5000);
            } else {
                ToastsStore.success(toaster.toasterText, 5000);
            }
            this.props.actions.removeToaster();
        }
    }

    render() {
        const {
            t,
            toaster,
            whitemarkBackground,
            whitemarkBtnColor,
            whitemarkFavicon,
            whitemarkLogo,
            whitemarkTitle,
            creatorName,
            openDepositDate,
            openDepositName
        } = this.props;

        const { sendFailed, newLink } = this.state;

        if (!sendFailed) {
            return (
                <>
                    {this.checkToaster(toaster)}
                    <ToastsContainer
                        position={ToastsContainerPosition.TOP_LEFT}
                        store={ToastsStore}
                        lightBackground
                    />
                <div className="main">
                    <Helmet>
                        <title>{whitemarkTitle}</title>
                        {<link rel="shortcut icon" href={whitemarkFavicon} />}
                        <style type="text/css">
                            {`
                                .main {
                                    background:url(${whitemarkBackground});
                                    background-size:cover;
                                    background-attachment: fixed;
                                }

                                .main>div.darker{
                                    background-color: rgba(32,32,48,0.7);
                                    min-height: 100vh;
                                }

                                .logo {
                                    background-image: url(${whitemarkLogo});
                                }

                                button.orangeBtn {
                                    background-color: ${whitemarkBtnColor};
                                }
                            `}
                        </style>
                    </Helmet>
                    <div className={/*whitemarkTitle === "LockSelf Deposit Box" ? "darker" :*/ "noDark"}>
                        <div className="mainContainerDeposit">
                            <div className="containerDeposit">
                                <div className="headerDeposit">
                                    <div className="logo"></div>
                                </div>
                                <div className="bodyDeposit">
                                    <div className="openDeposit">
                                        <div>
                                            <h3 className="senderLabel">{t("general.sender")}</h3>
                                            <div className="Card sender">
                                                <span>{creatorName ? this.getInitials(creatorName): ""}</span>
                                                <span>
                                                    <h1>{creatorName}</h1>
                                                </span>
                                            </div>
                                        </div>
                                        <div className="shareLabel">
                                            <h2>{t("general.title")}</h2>
                                        </div>
                                        <div className="Central">
                                            <div className="Card">
                                                <div className="boxInfo">
                                                    <div className="title">
                                                        <h2><small>{t("openDeposit.acces")}</small></h2>
                                                        <h2>{openDepositName}</h2>
                                                        <p className="date">{t("openDeposit.of")} {this.formatDate(openDepositDate)}</p>
                                                    </div>
                                                    <div className="depositEmail">
                                                        <span>{t("openDeposit.email")}</span>
                                                        <input
                                                            style={this.state.error ? {borderColor: "red"} : {}}
                                                            className="openDepositInput"
                                                            type="text"
                                                            placeholder={t("openDeposit.yourEmail")}
                                                            value={this.state.emailValue}
                                                            onChange={e => {
                                                                this.setState({emailValue: e.target.value, error: false, errorMessage: "", isSend: false});
                                                            }}
                                                            onKeyDown={(event) => {
                                                                if (event.key === 'Enter') {
                                                                    this.send()
                                                                }
                                                            }}
                                                        />
                                                        {this.state.error && (<span className="errorMessage">{this.state.errorMessage}</span>)}
                                                    </div>
                                                    <button style={this.state.isSend ? {backgroundColor: "lightgrey", cursor: "default"}: {}} className="orangeBtn" onClick={() => {
                                                        if(!this.state.isSend) {
                                                            this.send()
                                                        }
                                                    }}>{t("openDeposit.authCode")}</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <Footer/>
                                </div>
                            </div>
                            <RightSide depositAvailable={true}/>
                        </div>
                    </div>
                </div>
                </>
            )
        } else {
            return <FileNotFound
                whitemarkTitle={whitemarkTitle}
                whitemarkFavicon={whitemarkFavicon}
                whitemarkBackground={whitemarkBackground}
                whitemarkLogo={whitemarkLogo}
            />
            }

    }
}

 export default withTranslation()(OpenDeposit);
